function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var cruiseContainer = document.querySelector('.cruise-page .cruise-container');
        var cruiseFilterHeadings = cruiseContainer.querySelector('.cruise-filter-headings');
        var cruiseSummary = cruiseContainer.querySelector('.cruise-search-summary__values');
        var cruiseEditButton = cruiseContainer.querySelector('.cruise-search-summary__edit');
        var cruiseMobile = window.matchMedia('(max-width: 767px)');
        var collapseCruiseSearch = true;

        var updateCruiseSearch = function updateCruiseSearch() {
            var filter = cruiseContainer.querySelector('.ces-search-filter');
            if (!filter) {
                cruiseContainer.classList.remove('cruise-container--search-complete');
                return;
            }

            var form = filter.closest('form');
            form.id = 'cruise-search-form';

            if (!filter.querySelector('.cruise-filter-heading')) {
                filter.appendChild(cruiseFilterHeadings.content.cloneNode(true));
            }

            if (!collapseCruiseSearch || !cruiseMobile.matches || !cruiseContainer.querySelector('.ces-search-results__title')) {
                return;
            }

            var region = filter.querySelector('.ces-search-control:nth-child(5) .ces-select-box__value');
            var dates = Array.from(filter.querySelectorAll('.ces-date-picker__input'), function (input) {
                return input.value;
            });
            var travelers = Array.from(filter.querySelectorAll('.ces-person-control'), function (control) {
                var label = control.querySelector('.ces-person-control__label').textContent.trim();
                var value = control.querySelector('.ces-person-control__value').textContent.trim();
                return label + ': ' + value;
            });

            cruiseSummary.textContent = [region.textContent.trim(), dates.join(' – ')].concat(_toConsumableArray(travelers)).join(' · ');
            cruiseContainer.classList.add('cruise-container--search-complete');
            collapseCruiseSearch = false;

            if (form.contains(document.activeElement)) {
                cruiseEditButton.focus();
            }
        };

        cruiseContainer.addEventListener('submit', function (event) {
            if (event.target.id === 'cruise-search-form') {
                collapseCruiseSearch = true;
                requestAnimationFrame(updateCruiseSearch);
            }
        }, true);

        cruiseEditButton.addEventListener('click', function () {
            cruiseContainer.classList.remove('cruise-container--search-complete');
            cruiseContainer.querySelector('.ces-search-form__button_type_submit').focus();
        });

        new MutationObserver(updateCruiseSearch).observe(cruiseContainer, { childList: true, subtree: true });
        updateCruiseSearch();
    }, {}] }, {}, [1]);